import { map, pick } from 'ramda'
import { moduleState } from 'cerebral'
import Bluebird from 'bluebird'
import apiClient from '../../lib/util/api-client'
import { crudActions } from '../factories'

const attendanceService = apiClient.service('event-attendances')

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'eventAttendances' })

export const findIdsForInstance = async ({ props: { eventInstance } }) => {
  let attendances = []
  let totalCount = -1

  while (totalCount === -1 || totalCount > attendances.length) {
    const { total, data } = await attendanceService.find({
      query: { eventInstance, $select: '_id profile participationStatus', $limit: 50, $skip: attendances.length },
    })
    totalCount = total
    attendances = attendances.concat(map(pick(['_id', 'profile', 'participationStatus']), data))
  }

  return { eventAttendanceIds: attendances }
}

export const setSelectedAttendances = ({ props: { profiles = [], attendances = [] }, store }) => {
  store.set(moduleState`selected.profiles`, profiles)
  store.set(moduleState`selected.attendances`, attendances)
}

export const removeAttendancesInBulk = ({ props: { attendances = [], eventInstance }, store, app }) => {
  const showFeedback = app.getSequence('feedback.showFeedback')
  const toEventAttendances = app.getSequence('route.toEventAttendances')
  const removeAttendance = app.getSequence('eventAttendances.removeWithoutFeedback')

  Bluebird.mapSeries(attendances, (attendance) => removeAttendance({ id: attendance }))
    .then(() => {
      showFeedback({ title: 'Attendances removed' })
      toEventAttendances({ params: { eventInstance } })
      store.set(moduleState`selected.attendances`, [])
    })
    .catch(() => showFeedback({ title: 'There was a problem removing attendance', type: 'error' }))
}
